import tags from '../tags';

const {
  elements: { arcane, cold, fire, lightning },
  skillTypes: {
    cc,
    dot,
    channeling,
    weaken,
    resource,
    cooldown,
    damageBoost,
    toughness,
    mobility,
    pet,
  },
  skillTrees: { primary, secondary, defensive, force, conjuration, mastery },
} = tags;

export default [
  {
    name: 'Magic Missile',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, primary],
      },
      {
        name: 'Charged Blast',
        tags: [arcane, primary],
      },
      {
        name: 'Glacial Spike',
        tags: [cold, cc, primary],
      },
      {
        name: 'Split',
        tags: [arcane, primary],
      },
      {
        name: 'Seeker',
        tags: [arcane, primary],
      },
      {
        name: 'Conflagrate',
        tags: [fire, dot, primary],
      },
    ],
  },
  {
    name: 'Ray of Frost',
    runes: [
      {
        name: 'No Rune',
        tags: [cold, secondary, cc, channeling],
      },
      {
        name: 'Cold Blood',
        tags: [cold, secondary, cc, channeling],
      },
      {
        name: 'Numb',
        tags: [cold, secondary, cc, channeling],
      },
      {
        name: 'Black Ice',
        tags: [cold, secondary, cc, channeling, dot],
      },
      {
        name: 'Sleet Storm',
        tags: [cold, secondary, cc, channeling],
      },
      {
        name: 'Snow Blast',
        tags: [cold, secondary, cc, channeling, weaken],
      },
    ],
  },
  {
    name: 'Shock Pulse',
    runes: [
      {
        name: 'No Rune',
        tags: [lightning, primary],
      },
      {
        name: 'Explosive Bolts',
        tags: [cold, primary],
      },
      {
        name: 'Fire Bolts',
        tags: [fire, primary],
      },
      {
        name: 'Piercing Orb',
        tags: [lightning, primary],
      },
      {
        name: 'Power Affinity',
        tags: [arcane, primary, resource],
      },
      {
        name: 'Living Lightning',
        tags: [lightning, primary],
      },
    ],
  },
  {
    name: 'Frost Nova',
    runes: [
      {
        name: 'No Rune',
        tags: [cold, cooldown, defensive, cc],
      },
      {
        name: 'Shatter',
        tags: [cold, cooldown, defensive, cc],
      },
      {
        name: 'Cold Snap',
        tags: [cold, cooldown, defensive, cc],
      },
      {
        name: 'Frozen Mist',
        tags: [cold, cooldown, defensive, dot],
      },
      {
        name: 'Deep Freeze',
        tags: [cold, cooldown, defensive, cc, damageBoost],
      },
      {
        name: 'Bone Chill',
        tags: [cold, cooldown, defensive, cc, weaken],
      },
    ],
  },
  {
    name: 'Arcane Orb',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, secondary],
      },
      {
        name: 'Obliteration',
        tags: [arcane, secondary],
      },
      {
        name: 'Arcane Orbit',
        tags: [arcane, secondary],
      },
      {
        name: 'Spark',
        tags: [lightning, secondary, damageBoost],
      },
      {
        name: 'Scorch',
        tags: [fire, secondary, dot],
      },
      {
        name: 'Frozen Orb',
        tags: [cold, secondary],
      },
    ],
  },
  {
    name: 'Diamond Skin',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, defensive, toughness, arcane],
      },
      {
        name: 'Crystal Shell',
        tags: [cooldown, defensive, toughness, arcane],
      },
      {
        name: 'Prism',
        tags: [cooldown, defensive, toughness, resource, arcane],
      },
      {
        name: 'Sleek Shell',
        tags: [cooldown, defensive, toughness, mobility, arcane],
      },
      {
        name: 'Enduring Skin',
        tags: [cooldown, defensive, toughness, arcane],
      },
      {
        name: 'Diamond Shards',
        tags: [arcane, cooldown, defensive, toughness],
      },
    ],
  },
  {
    name: 'Wave of Force',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, force],
      },
      {
        name: 'Impactful Wave',
        tags: [arcane, force, cooldown, cc],
      },
      {
        name: 'Debilitating Force',
        tags: [arcane, force, weaken],
      },
      {
        name: 'Arcane Attunement',
        tags: [arcane, force, damageBoost],
      },
      {
        name: 'Static Pulse',
        tags: [lightning, force, resource],
      },
      {
        name: 'Heat Wave',
        tags: [fire, force],
      },
    ],
  },
  {
    name: 'Spectral Blade',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, primary],
      },
      {
        name: 'Flame Blades',
        tags: [fire, primary, damageBoost],
      },
      {
        name: 'Siphoning Blade',
        tags: [arcane, primary, resource],
      },
      {
        name: 'Thrown Blade',
        tags: [lightning, primary],
      },
      {
        name: 'Barrier Blades',
        tags: [arcane, primary, toughness],
      },
      {
        name: 'Ice Blades',
        tags: [cold, primary, cc, damageBoost],
      },
    ],
  },
  {
    name: 'Arcane Torrent',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, secondary, channeling],
      },
      {
        name: 'Flame Ward',
        tags: [fire, secondary, channeling, toughness],
      },
      {
        name: 'Death Blossom',
        tags: [arcane, secondary, channeling],
      },
      {
        name: 'Arcane Mines',
        tags: [arcane, secondary, channeling, cc, weaken],
      },
      {
        name: 'Static Discharge',
        tags: [lightning, secondary, channeling],
      },
      {
        name: 'Cascade',
        tags: [arcane, secondary, channeling],
      },
    ],
  },
  {
    name: 'Energy Twister',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, force],
      },
      {
        name: 'Mistral Breeze',
        tags: [cold, force],
      },
      {
        name: 'Gale Force',
        tags: [fire, force, weaken],
      },
      {
        name: 'Raging Storm',
        tags: [arcane, force],
      },
      {
        name: 'Wicked Wind',
        tags: [arcane, force],
      },
      {
        name: 'Storm Chaser',
        tags: [lightning, force],
      },
    ],
  },
  {
    name: 'Ice Armor',
    runes: [
      {
        name: 'No Rune',
        tags: [toughness, conjuration, cc, cold],
      },
      {
        name: 'Chilling Aura',
        tags: [toughness, conjuration, cc, cold],
      },
      {
        name: 'Crystallize',
        tags: [toughness, conjuration, cc, cold],
      },
      {
        name: 'Jagged Ice',
        tags: [cold, toughness, conjuration, cc],
      },
      {
        name: 'Ice Reflect',
        tags: [cold, toughness, conjuration, cc],
      },
      {
        name: 'Frozen Storm',
        tags: [cold, toughness, conjuration, cc],
      },
    ],
  },
  {
    name: 'Electrocute',
    runes: [
      {
        name: 'No Rune',
        tags: [lightning, primary],
      },
      {
        name: 'Chain Lightning',
        tags: [lightning, primary],
      },
      {
        name: 'Forked Lightning',
        tags: [fire, primary],
      },
      {
        name: 'Lightning Blast',
        tags: [lightning, primary],
      },
      {
        name: 'Surge of Power',
        tags: [lightning, resource, primary],
      },
      {
        name: 'Arc Lightning',
        tags: [lightning, primary],
      },
    ],
  },
  {
    name: 'Slow Time',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, toughness, cc, weaken, defensive, arcane],
      },
      {
        name: 'Time Shell',
        tags: [cooldown, toughness, cc, weaken, defensive, arcane],
      },
      {
        name: 'Exhaustion',
        tags: [cooldown, toughness, cc, weaken, defensive, arcane],
      },
      {
        name: 'Time Warp',
        tags: [cooldown, toughness, cc, weaken, defensive, arcane],
      },
      {
        name: 'Point of No Return',
        tags: [cooldown, toughness, cc, weaken, defensive, arcane],
      },
      {
        name: 'Stretch Time',
        tags: [cooldown, toughness, cc, weaken, defensive, damageBoost, arcane],
      },
    ],
  },
  {
    name: 'Storm Armor',
    runes: [
      {
        name: 'No Rune',
        tags: [lightning, conjuration],
      },
      {
        name: 'Reactive Armor',
        tags: [lightning, conjuration],
      },
      {
        name: 'Power of the Storm',
        tags: [lightning, conjuration],
      },
      {
        name: 'Thunder Storm',
        tags: [lightning, conjuration],
      },
      {
        name: 'Scramble',
        tags: [lightning, conjuration, mobility],
      },
      {
        name: 'Shocking Aspect',
        tags: [lightning, conjuration],
      },
    ],
  },
  {
    name: 'Explosive Blast',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, mastery],
      },
      {
        name: 'Unleashed',
        tags: [arcane, mastery],
      },
      {
        name: 'Flash',
        tags: [lightning, mastery],
      },
      {
        name: 'Short Fuse',
        tags: [fire, mastery],
      },
      {
        name: 'Obliterate',
        tags: [cold, mastery],
      },
      {
        name: 'Chain Reaction',
        tags: [fire, mastery],
      },
    ],
  },
  {
    name: 'Magic Weapon',
    runes: [
      {
        name: 'No Rune',
        tags: [damageBoost, arcane],
      },
      {
        name: 'Electrify',
        tags: [lightning, damageBoost],
      },
      {
        name: 'Force Weapon',
        tags: [damageBoost, arcane],
      },
      {
        name: 'Conduit',
        tags: [damageBoost, resource, arcane],
      },
      {
        name: 'Ignite',
        tags: [fire, damageBoost],
      },
      {
        name: 'Deflection',
        tags: [damageBoost, toughness, arcane],
      },
    ],
  },
  {
    name: 'Hydra',
    runes: [
      {
        name: 'No Rune',
        tags: [pet, fire, force],
      },
      {
        name: 'Arcane Hydra',
        tags: [pet, arcane, force],
      },
      {
        name: 'Lightning Hydra',
        tags: [pet, lightning, force],
      },
      {
        name: 'Blazing Hydra',
        tags: [pet, fire, force, dot],
      },
      {
        name: 'Frost Hydra',
        tags: [pet, cold, force],
      },
      {
        name: 'Mammoth Hydra',
        tags: [pet, fire, force],
      },
    ],
  },
  {
    name: 'Disintegrate',
    runes: [
      {
        name: 'No Rune',
        tags: [channeling, arcane, secondary],
      },
      {
        name: 'Convergence',
        tags: [channeling, fire, secondary],
      },
      {
        name: 'Volatility',
        tags: [channeling, arcane, secondary],
      },
      {
        name: 'Entropy',
        tags: [channeling, arcane, secondary],
      },
      {
        name: 'Chaos Nexus',
        tags: [channeling, arcane, secondary],
      },
      {
        name: 'Intensify',
        tags: [channeling, arcane, secondary, weaken],
      },
    ],
  },
  {
    name: 'Familiar',
    runes: [
      {
        name: 'No Rune',
        tags: [pet, arcane, conjuration],
      },
      {
        name: 'Sparkflint',
        tags: [pet, fire, conjuration, damageBoost],
      },
      {
        name: 'Icicle',
        tags: [pet, cold, cc, conjuration],
      },
      {
        name: 'Ancient Guardian',
        tags: [pet, arcane, conjuration],
      },
      {
        name: 'Arcanot',
        tags: [pet, arcane, conjuration, resource],
      },
      {
        name: 'Cannoneer',
        tags: [pet, arcane, conjuration],
      },
    ],
  },
  {
    name: 'Teleport',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, mobility, defensive, arcane],
      },
      {
        name: 'Safe Passage',
        tags: [cooldown, mobility, defensive, toughness, arcane],
      },
      {
        name: 'Wormhole',
        tags: [cooldown, mobility, defensive, arcane],
      },
      {
        name: 'Reversal',
        tags: [cooldown, mobility, defensive, arcane],
      },
      {
        name: 'Fracture',
        tags: [cooldown, mobility, defensive, arcane],
      },
      {
        name: 'Calamity',
        tags: [arcane, cc, cooldown, mobility, defensive],
      },
    ],
  },
  {
    name: 'Mirror Image',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, mastery, pet, arcane],
      },
      {
        name: 'Hard Light',
        tags: [cooldown, mastery, pet, arcane],
      },
      {
        name: 'Duplicates',
        tags: [cooldown, mastery, pet, arcane],
      },
      {
        name: 'Mocking Demise',
        tags: [arcane, cc, cooldown, mastery, pet],
      },
      {
        name: 'Extension of Will',
        tags: [cooldown, mastery, pet, arcane],
      },
      {
        name: 'Mirror Mimics',
        tags: [cooldown, mastery, pet, arcane],
      },
    ],
  },
  {
    name: 'Meteor',
    runes: [
      {
        name: 'No Rune',
        tags: [fire, dot, force],
      },
      {
        name: 'Thunder Crash',
        tags: [lightning, dot, force],
      },
      {
        name: 'Star Pact',
        tags: [arcane, force],
      },
      {
        name: 'Comet',
        tags: [cold, dot, force],
      },
      {
        name: 'Meteor Shower',
        tags: [fire, force],
      },
      {
        name: 'Molten Impact',
        tags: [fire, dot, force, cooldown],
      },
    ],
  },
  {
    name: 'Blizzard',
    runes: [
      {
        name: 'No Rune',
        tags: [cold, dot, force],
      },
      {
        name: 'Lightning Storm',
        tags: [lightning, dot, force],
      },
      {
        name: 'Frozen Solid',
        tags: [cold, dot, cc, force],
      },
      {
        name: 'Snowbound',
        tags: [cold, dot, force],
      },
      {
        name: 'Apocalypse',
        tags: [fire, dot, force],
      },
      {
        name: 'Unrelenting Storm',
        tags: [cold, dot, force],
      },
    ],
  },
  {
    name: 'Energy Armor',
    runes: [
      {
        name: 'No Rune',
        tags: [toughness, conjuration, arcane],
      },
      {
        name: 'Absorption',
        tags: [toughness, resource, conjuration, arcane],
      },
      {
        name: 'Pinpoint Barrier',
        tags: [toughness, conjuration, damageBoost, arcane],
      },
      {
        name: 'Energy Tap',
        tags: [toughness, conjuration, arcane],
      },
      {
        name: 'Force Armor',
        tags: [toughness, conjuration, arcane],
      },
      {
        name: 'Prismatic Armor',
        tags: [toughness, conjuration, arcane],
      },
    ],
  },
  {
    name: 'Archon',
    runes: [
      {
        name: 'No Rune',
        tags: [arcane, cooldown, damageBoost, toughness, mastery],
      },
      {
        name: 'Combustion',
        tags: [fire, cooldown, damageBoost, toughness, mastery],
      },
      {
        name: 'Teleport',
        tags: [arcane, cooldown, damageBoost, toughness, mastery],
      },
      {
        name: 'Pure Power',
        tags: [lightning, cooldown, damageBoost, toughness, mastery],
      },
      {
        name: 'Slow Time',
        tags: [cold, cc, cooldown, damageBoost, toughness, mastery],
      },
      {
        name: 'Improved Archon',
        tags: [arcane, cooldown, damageBoost, toughness, mastery],
      },
    ],
  },
  {
    name: 'Black Hole',
    runes: [
      {
        name: 'No Rune',
        tags: [cc, arcane, dot, mastery],
      },
      {
        name: 'Supermassive',
        tags: [cc, lightning, dot, mastery],
      },
      {
        name: 'Absolute Zero',
        tags: [cc, cold, dot, mastery],
      },
      {
        name: 'Event Horizon',
        tags: [cc, arcane, dot, mastery],
      },
      {
        name: 'Blazar',
        tags: [cc, fire, dot, mastery],
      },
      {
        name: 'Spellsteal',
        tags: [cc, arcane, dot, mastery, weaken, damageBoost],
      },
    ],
  },
];
